import { call, put } from 'redux-saga/effects';
import ActionTypes from '../actionTypes';

export function* getAllNIL(action): Generator<any, void, empty> {
  try {
    const response = yield call(() => APIService.apiRequest('GET_ALL_NIL', 'GET', {
      routeParams: {},
      query: {
        page: action?.page || 0,
        pageSize: action?.pageSize || 10,
      },
    }));

    yield put({
      type: ActionTypes.NIL.getAll.SUCCESS,
      page: action?.page,
      response,
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('error', error);
    yield put({
      type: ActionTypes.NIL.getAll.ERROR,
      error,
    });
  }
}

export function* postNIL(action): Generator<any, void, empty> {
  try {
    const response = yield call(() => APIService.apiRequest('POST_NIL', 'POST', {
      body: action?.body ?? {},
    }));

    yield put({
      type: ActionTypes.NIL.post.SUCCESS,
      response,
    });

    yield put({
      type: ActionTypes.notifications.add.START,
      payload: {
        variant: 'success',
        content: 'Successfully created NIL Application!',
      },
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('error', error);
    yield put({
      type: ActionTypes.NIL.post.ERROR,
      error,
    });

    yield put({
      type: ActionTypes.notifications.add.START,
      payload: {
        variant: 'error',
        content: 'There was an error creating the NIL Applicaiton.',
      },
    });
  }
}

export function* getNIL(action): Generator<any, void, empty> {
  try {
    const response = yield call(() => APIService.apiRequest('GET_ONE_NIL', 'GET', {
      routeParams: {
        id: action?.id,
      },
    }));
    yield put({
      type: ActionTypes.NIL.get.SUCCESS,
      id: action?.id,
      response,
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('error', error);
    yield put({
      type: ActionTypes.NIL.get.ERROR,
      error,
    });

    yield put({
      type: ActionTypes.notifications.add.START,
      payload: {
        variant: 'error',
        content: 'There was an error getting the NIL Applicaiton.',
      },
    });
  }
}

export function* patchNIL(action): Generator<any, void, empty> {
  const actionId = action?.id ?? 'me';
  try {
    const response = yield call(() => APIService.apiRequest('PATCH_NIL', 'PATCH', {
      routeParams: {
        id: actionId,
      },
      body: action?.body ?? [],
    }));
    yield put({
      type: ActionTypes.NIL.patch.SUCCESS,
      id: actionId,
      response,
    });

    yield put({
      type: ActionTypes.notifications.add.START,
      payload: {
        variant: 'success',
        content: 'Successfully updated NIL Post!',
      },
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('error', error);
    yield put({
      type: ActionTypes.NIL.patch.ERROR,
      id: actionId,
      error,
    });

    yield put({
      type: ActionTypes.notifications.add.START,
      payload: {
        variant: 'error',
        content: 'There was an error updating the NIL Post.',
      },
    });
  }
}

export function* deleteNIL(action): Generator<any, void, empty> {
  const actionId = action?.id ?? 'me';
  try {
    const response = yield call(() => APIService.apiRequest('DELETE_NIL', 'DELETE', {
      routeParams: {
        id: actionId,
      },
    }));
    yield put({
      type: ActionTypes.NIL.delete.SUCCESS,
      id: actionId,
      response,
    });
    yield put({
      type: ActionTypes.notifications.add.START,
      payload: {
        variant: 'success',
        content: 'Successfully deleted NIL Application!',
      },
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('error', error);
    yield put({
      type: ActionTypes.NIL.delete.ERROR,
      id: actionId,
      error,
    });

    yield put({
      type: ActionTypes.notifications.add.START,
      payload: {
        variant: 'error',
        content: 'There was an error deleting the NIL Applicaiton.',
      },
    });
  }
}

export function* getNILApplications(action): Generator<any, void, empty> {
  try {
    const response = yield call(() => APIService.apiRequest('GET_NIL_APPLICATIONS', 'GET', {
      routeParams: {
        id: action?.id,
      },
      query: {
        ...(action?.query || {}),
        page: action?.query?.page || 0,
        pageSize: action?.query?.pageSize || 20,
      },
    }));

    yield put({
      type: ActionTypes.NIL.applications.getAll.SUCCESS,
      id: action?.id,
      response,
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('error', error);
    yield put({
      type: ActionTypes.NIL.applications.getAll.ERROR,
      error,
    });

    yield put({
      type: ActionTypes.notifications.add.START,
      payload: {
        variant: 'error',
        content: 'There was an error getting the NIL Applicaitons.',
      },
    });
  }
}
